<template>
    <div>
        <v-view :tableData="tableData"
                :tableProps="tableProps"
                :modalProps="modalProps"
                :columns="columns"
                :routes="routes"
                :initialSort="initialSort"
                :buttonsVisibility="buttonsVisibility"
                :tooltipColumns="tooltipColumns"
                :renderColumnValue="renderColumnValue"
                v-model:selectedRows="selectedRows">

            <template #crud="formProps">
                <SellerForm :formProps="formProps"> </SellerForm>
            </template>
            <template #search="searchProps">
                <SellerSearch :searchProps="searchProps"> </SellerSearch>
            </template>
        </v-view>
    </div>
</template>

<script setup>
import { ref } from "vue";
import SellerForm from "./SellerForm.vue";
import SellerSearch from "./SellerSearch.vue";
import { __ } from "@pages/Helper/utils.js";

const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    tooltipColumns: Object,
    initialSort: Object,
    buttonsVisibility: Object,
});

const selectedRows = ref([]);

//------------------------------------------------------------------------------

const renderColumnValue = (field, value) => {
    switch (field) {
        case "is_active":
            return value == 1 ? '<span class="flex justify-content-center"><i class="fa-solid fa-person-running" style="font-size:20px;color:royalblue;"></i></span>' : "";

        default:
            return value;
    }
};

//------------------------------------------------------------------------------

</script>

<style lang="scss" scoped></style>
